// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "SlideShow") {
    $this.find('.hero-slider-active').SlideShow();
  }else if($this.data('section') == "TabWithProduct") {
    $this.find('.product-carousel-4').TabWithProduct();
  }else if($this.data('section') == "CollectionBanner") {
    $this.find('.product-banner-carousel').CollectionBanner();
  }else if($this.data('section') == "FeatureCollection") {
    $this.find('.product-carousel-4_2').FeatureCollectionActive();
  }else if($this.data('section') == "TestimonialSection") {
    $this.find('.testimonial-content-carousel').TestimonialContent();
    $this.find('.testimonial-thumb-carousel').TestimonialThumb();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.BannerWithCollection();
  }else if($this.data('section') == "LatestBlog") {
    $this.find('.blog-carousel-active').LatestBlog();
  }else if($this.data('section') == "BrandLogo") {
    $this.find('.brand-logo-carousel').BrandLogoActive();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.group-list-carousel--3').CollectionThumbnail();
  }else if($this.data('section') == "HotDeals") {
    $this.find('.deals-carousel-active').HotDeals();
  }else if($this.data('section') == "CollectionBannerSlideshow") {
    $this.find('.hero-slider-active-4').CollectionBannerSlideshow();
  }else if($this.data('section') == "RelatedProduct") {
    $this.find('.product-carousel-5').RelatedProduct();
  }else if($this.data('section') == "CustomCollection") {
    $this.find('.product-carousel-6').CustomCollection();
  }else if($this.data('section') == "HeaderSection") {
    $this.HeaderSection();
  }else if($this.data('section') == "CollectionTemplate") {
    $this.CollectionTemplateActivation();
  }else if($this.data('section') == "InstagramSlider") {
    $this.InstagramSection();
  }else if($this.data('section') == "ProductTemplate") {
    $this.ProductTemplate();
  }else if($this.data('section') == "MultipleBanner") {
    $this.MultipleBanner();
  }else if($this.data('section') == "FooterSection") {
    $this.FooterSection();
  }else if($this.data('section') == "AboutInfo") {
    $this.AboutInfo();
  }else if($this.data('section') == "TeamMember") {
    $this.TeamMember();
  }else if($this.data('section') == "BlogTemplate") {
    $this.BlogTemplate();
  }else if($this.data('section') == "ArticleTemplate") {
    $this.BlogTemplate();
  }else{}   
}

// Slideshow active js
$.fn.SlideShow = function() {
  var $SlideShowVAR = this;
  $SlideShowVAR.slick({
    fade: true,
    speed: 1000,
    dots: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',responsive: [{
      breakpoint: 992,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  // Background Image JS start
  var bgSelector = $(".bg-img");
  bgSelector.each(function (index, elem) {
    var element = $(elem),
        bgSource = element.data('bg');
    element.css('background-image', 'url(' + bgSource + ')');
  });
};

// Tab With Product active js
$.fn.TabWithProduct = function() {
  var $TabWithProductVAR = this;
  $TabWithProductVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// product banner active js
$.fn.CollectionBanner = function() {
  var $CollectionBannerVAR = this;
  $CollectionBannerVAR.slick({
    speed: 1000,
    arrows: false,});
  $("img.lazyload").lazyload();
};

// Featured Collection active js
$.fn.FeatureCollectionActive = function() {
  var $FeatureCollectionActiveVAR = this;
  if($FeatureCollectionActiveVAR.length > 0){
    $FeatureCollectionActiveVAR.slick({
      speed: 1000,
      adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  };
  $("img.lazyload").lazyload();
};

// Testimonial active js
$.fn.TestimonialContent = function() {
  var $TestimonialContentVAR = this;
  $TestimonialContentVAR.slick({
    arrows: false,
    asNavFor: '.testimonial-thumb-carousel',});
};
$.fn.TestimonialThumb = function() {
  var $TestimonialThumbVAR = this;
  $TestimonialThumbVAR.slick({
    slidesToShow: 3,
    asNavFor: '.testimonial-content-carousel',
    centerMode: true,
    arrows: false,centerPadding: 0,
    focusOnSelect: true
  });
};

// Banner with collection active js
$.fn.BannerWithCollection = function() {
  $('.group-list-carousel').each(function () {
    var $this = $(this);
    var $arrowContainer = $(this).parent().siblings('.section-title-append').find('.slick-append');
    $this.slick({
      infinite: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',appendArrows: $arrowContainer
    });
  });
  $("img.lazyload").lazyload();
};

// Latest blog active js
$.fn.LatestBlog = function() {
  var $LatestBlogVAR = this;
  $LatestBlogVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Brand logo active js
$.fn.BrandLogoActive = function() {
  var $BrandLogoVAR = this;
  $BrandLogoVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Collection Thumbnail active js
$.fn.CollectionThumbnail = function() {
  var $CollectionThumbnailVAR = this;
  $CollectionThumbnailVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Hot Deal active js
$.fn.HotDeals = function() {
  var $HotDealsVAR = this;
  $HotDealsVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Collection Banner active js
$.fn.CollectionBannerSlideshow = function() {
  var $CollectionBannerSlideshowVAR = this;
  $CollectionBannerSlideshowVAR.slick({
    speed: 1000,
    arrows: false,});
  $("img.lazyload").lazyload();
};

// Related Product active js
$.fn.RelatedProduct = function() {
  var $RelatedProductVAR = this;
  $RelatedProductVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Related Product active js
$.fn.CustomCollection = function() {
  var $CustomCollectionVAR = this;
  $CustomCollectionVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Header Section active js
$.fn.HeaderSection = function() {
  // offcanvas minicart button js
  $(".minicart-btn").on('click', function(){
    $("body").addClass('fix');
    $(".minicart-inner").addClass('show')
  })

  $(".offcanvas-close, .minicart-close,.offcanvas-overlay").on('click', function(){
    $("body").removeClass('fix');
    $(".minicart-inner").removeClass('show')
  });
  // Search trigger js
  $(".search-trigger").on('click', function(){
    $(".header-search-box").toggleClass('search-box-open');
  });
  // Sticky menu
  var $window = $(window);
  $window.on('scroll', function () {
    var scroll = $window.scrollTop();
    if (scroll < 300) {
      $(".sticky").removeClass("is-sticky");
    } else {
      $(".sticky").addClass("is-sticky");
    }
  });// Off Canvas Open close
  $(".mobile-menu-btn").on('click', function () {
    $("body").addClass('fix');
    $(".off-canvas-wrapper").addClass('open');
  });

  $(".btn-close-off-canvas,.off-canvas-overlay").on('click', function () {
    $("body").removeClass('fix');
    $(".off-canvas-wrapper").removeClass('open');
  });

  // offcanvas mobile menu
  var $offCanvasNav = $('.mobile-menu'),
      $offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');

  /*Add Toggle Button With Off Canvas Sub Menu*/
  $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');

  /*Close Off Canvas Sub Menu*/
  $offCanvasNavSubMenu.slideUp();

  /*Category Sub Menu Toggle*/
  $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
    var $this = $(this);
    if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length){
        $this.parent('li').removeClass('active');
        $this.siblings('ul').slideUp();
      } else {
        $this.parent('li').addClass('active');
        $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
        $this.closest('li').siblings('li').find('ul:visible').slideUp();
        $this.siblings('ul').slideDown();
      }
    }
  });
  $("img.lazyload").lazyload();
};

// Collection Template active js
$.fn.CollectionTemplateActivation = function() {
  // product view mode change js
  $('.product-view-mode a').on('click', function (e) {
    e.preventDefault();
    var shopProductWrap = $('.shop-product-wrap');
    var viewMode = $(this).data('target');
    $('.product-view-mode a').removeClass('active');
    $(this).addClass('active');
    shopProductWrap.removeClass('grid-view list-view').addClass(viewMode);
  });
  $("img.lazyload").lazyload();
};

// Instgram active js
$.fn.InstagramSection = function(){
  var activation = this.find('[data-username]'),
      activeId = activation.attr('id'),
      clientUsername = activation.attr('data-username'),
      instagramHastag = activation.attr('data-hashtag'),
      ItemsLimit = activation.attr('data-limit'),
      imageSize = activation.attr('data-size'),
      instaslider = ".instagram-carousel";

  $.instagramFeed({
    'tag': instagramHastag,
    'username': clientUsername,
    'container': "#"+activeId,
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'styling': false,
    'items': ItemsLimit,
    'margin': 1,
    'image_size': imageSize
  });

  var $instagramNews = "#"+activeId+instaslider,
      $slidesToShow = activation.data('slidetoshow'),
      $slideshowtablet = activation.data('slideshowtablet'),
      $slideshowsmmobile = activation.data('slideshowsmmobile');

  $($instagramNews).on("DOMNodeInserted", function (e) {
    if (e.target.className == 'instagram_gallery') {
      $("." + e.target.className).slick({
        slidesToShow: $slidesToShow,
        slidesToScroll: 1,
        
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: $slideshowsmmobile,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: $slideshowtablet,
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: $slideshowtablet,
            }
          }

        ]
      })
    }
  });  
};

// Product Template active js
$.fn.ProductTemplate = function() {
  // product details slider nav active
  $('.pro-nav').slick({
    slidesToShow: 4,
    focusOnSelect: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Multiple Banner active js
$.fn.MultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Footer Section active js
$.fn.FooterSection = function() {
  $("img.lazyload").lazyload();
};

// About section active js
$.fn.AboutInfo = function() {
  $("img.lazyload").lazyload();
};

// Team member section active js
$.fn.TeamMember = function() {
  $("img.lazyload").lazyload();
};

// Blog template active js
$.fn.BlogTemplate = function() {
  $("img.lazyload").lazyload();
};

// Article template active js
$.fn.ArticleTemplate = function() {
  $("img.lazyload").lazyload();
};


(function($) {
  "use strict";

  jQuery(document).ready(function(){
    // All jQuery activation code paste here    
    
    

	// tooltip active js
	$('[data-toggle="tooltip"]').tooltip();

    
    // Product grid color variant activation code. 
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });

  });
  
})(jQuery);

/* sdt-whatsapp-js-fallback:start */
(function(){
  var href = 'https://wa.me/8616668297697?text=Hello%2C%20I%20want%20to%20know%20more%20about%20your%20anime%20figures.';
  var markerClass = 'sdt-whatsapp-float-v20260609';
  var styleId = 'sdt-whatsapp-float-fallback-style';
  function ready(fn){
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn, { once: true }); }
    else { fn(); }
  }
  ready(function(){
    if(document.querySelector('.sdt-whatsapp-float')) return;
    if(!document.body) return;
    if(!document.getElementById(styleId)){
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = '.sdt-whatsapp-float{position:fixed;right:22px;bottom:116px;z-index:99990;display:inline-flex;align-items:center;justify-content:center;gap:10px;min-width:58px;height:58px;padding:0 16px 0 13px;border-radius:999px;background:#25D366;color:#fff!important;text-decoration:none!important;box-shadow:0 12px 28px rgba(18,140,74,.28),0 0 0 1px rgba(255,255,255,.42) inset;transition:transform 180ms ease,box-shadow 180ms ease,background-color 180ms ease;-webkit-tap-highlight-color:transparent}.sdt-whatsapp-float:hover,.sdt-whatsapp-float:focus{color:#fff!important;background:#1ebe5d;text-decoration:none!important;transform:translateY(-2px);box-shadow:0 16px 34px rgba(18,140,74,.34),0 0 0 1px rgba(255,255,255,.52) inset}.sdt-whatsapp-float:focus-visible{outline:3px solid rgba(37,211,102,.28);outline-offset:4px}.sdt-whatsapp-float__mark{display:inline-flex;align-items:center;justify-content:center;flex:0 0 34px;width:34px;height:34px;border-radius:50%;background:#fff;color:#168449;font-size:12px;font-weight:800;line-height:1;letter-spacing:0}.sdt-whatsapp-float__label{display:inline-block;max-width:0;overflow:hidden;white-space:nowrap;opacity:0;color:#fff;font-size:14px;font-weight:700;line-height:1;letter-spacing:0;transform:translateX(4px);transition:max-width 220ms ease,opacity 160ms ease,transform 180ms ease}@media (hover:hover) and (min-width:768px){.sdt-whatsapp-float:hover .sdt-whatsapp-float__label,.sdt-whatsapp-float:focus .sdt-whatsapp-float__label{max-width:170px;opacity:1;transform:translateX(0)}}@media only screen and (max-width:767.98px){.sdt-whatsapp-float{right:auto;left:16px;bottom:calc(18px + env(safe-area-inset-bottom));width:54px;min-width:54px;height:54px;padding:0;gap:0;box-shadow:0 10px 24px rgba(18,140,74,.30),0 0 0 1px rgba(255,255,255,.42) inset}.sdt-whatsapp-float:hover,.sdt-whatsapp-float:focus{transform:none}.sdt-whatsapp-float__mark{flex-basis:32px;width:32px;height:32px;font-size:11px}.sdt-whatsapp-float__label{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}}@media (prefers-reduced-motion:reduce){.sdt-whatsapp-float,.sdt-whatsapp-float__label{transition:none}}';
      document.head.appendChild(style);
    }
    var link = document.createElement('a');
    link.className = 'sdt-whatsapp-float ' + markerClass;
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', 'Chat with SenDao Toys on WhatsApp');
    link.setAttribute('data-sdt-whatsapp-float', '2026-06-09');
    link.innerHTML = '<span class="sdt-whatsapp-float__mark" aria-hidden="true"><svg class="sdt-whatsapp-float__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg></span><span class="sdt-whatsapp-float__label">Chat on WhatsApp</span>';
    document.body.appendChild(link);
  });
})();
/* sdt-whatsapp-js-fallback:end */

/* sendaotoys-language-switcher-fallback:start */
(function(){
  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }
  function cleanPath(path){
    path = path || '/';
    var prefixes = ['/es-mx', '/pt-br', '/es', '/pt'];
    for(var i = 0; i < prefixes.length; i += 1){
      var prefix = prefixes[i];
      if(path === prefix) return '/';
      if(path.indexOf(prefix + '/') === 0) return path.slice(prefix.length) || '/';
    }
    return path;
  }
  function urlFor(prefix, clean){
    if(clean === '/') return prefix ? prefix + '/' : '/';
    return prefix + clean;
  }
  function currentIso(){
    var lang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    if(lang.indexOf('pt') === 0) return 'pt-BR';
    if(lang.indexOf('es') === 0) return 'es';
    return 'en';
  }
  function renderPicker(id){
    var iso = currentIso();
    var clean = cleanPath(window.location.pathname);
    var currentLabel = iso === 'pt-BR' ? 'PT' : iso.toUpperCase();
    var items = [
      { iso: 'en', label: 'English', code: 'EN', href: urlFor('', clean), hreflang: 'en' },
      { iso: 'es', label: 'Español', code: 'ES', href: urlFor('/es-mx', clean), hreflang: 'es-MX' },
      { iso: 'pt-BR', label: 'Português', code: 'PT', href: urlFor('/pt-br', clean), hreflang: 'pt-BR' }
    ];
    return '<div class="language-switcher" id="' + id + '" data-language-switcher>' +
      '<details class="language-switcher__details">' +
      '<summary class="language-switcher__summary" aria-label="Change language">' +
      '<span class="language-switcher__label">' + currentLabel + '</span>' +
      '<span class="language-switcher__chevron" aria-hidden="true">&#9662;</span>' +
      '</summary><div class="language-switcher__menu" role="list">' +
      items.map(function(item){
        var active = item.iso === iso ? ' is-active' : '';
        var current = item.iso === iso ? ' aria-current="true"' : '';
        return '<a href="' + item.href + '" hreflang="' + item.hreflang + '" class="language-switcher__option' + active + '"' + current + '>' +
          '<span class="language-switcher__name">' + item.label + '</span>' +
          '<span class="language-switcher__code">' + item.code + '</span>' +
          '</a>';
      }).join('') + '</div></details></div>';
  }
  ready(function(){
    var desktop = document.querySelector('.hdr5-lang-switcher');
    if(desktop) desktop.innerHTML = renderPicker('HeaderLanguageForm');
    var mobile = document.querySelector('.mobile-language-switcher');
    if(mobile) mobile.innerHTML = renderPicker('MobileLanguageForm');
  });
})();
/* sendaotoys-language-switcher-fallback:end */
